<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券二维码</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col :span="4">
          <el-date-picker v-model="dateStart" type="date" placeholder="优惠券有效期起"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker v-model="dateEnd" type="date" placeholder="优惠券有效期止"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-select v-model="couponVal" placeholder="请选择优惠券金额">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="primary"  @click="ManualGenqrcode" >生成二维码</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="success" @click="reGenQrcode">刷新二维码</el-button>
        </el-col>
      </el-row>

      <el-card :body-style="{ padding: '0px' }" class="qr-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: 600">请扫描下方二维码，领取优惠券</span>
        </div>
        <!-- <img
          src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
          class="image"
        /> -->
         <div id="qrcode" class="image"></div>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2' // 引入qrcode
import { dateFormat } from '@/utils/utils'
export default {
  created () { // 进入页面，查询商户信息
    this.queryMerchantInfo()
  },
  mounted () {

  },
  beforeDestroy () { // 离开页面之前销毁定时器
    this.destroyTimer()
  },
  data () {
    return {
      dateStart: '', // 优惠券有效期起
      dateEnd: '', // 优惠券有效期止
      couponVal: '', // 优惠券金额，默认20
      myTimer: null,
      qrLink: '',
      options: []
    }
  },
  methods: {

    // 生成二维码按钮触发函数
    ManualGenqrcode () {
      if (this.qrcode()) { // 生成二维码成功，则添加刷新定时器
        this.myTimer = setInterval(this.qrcode, 60000)
      } else {
        this.destroyTimer()
      }
    },

    // 刷新二维码按钮触发函数
    reGenQrcode () {
      // 判断二维码之前是否生成
      if (document.getElementById('qrcode').innerHTML === '') {
        this.$message.error('按步骤【生成二维码】后，才能刷新二维码')
        return false
      }
      // 判断是否有定时器，有则清除
      this.destroyTimer()
      if (this.qrcode()) { // 生成二维码成功，则添加刷新定时器
        this.myTimer = setInterval(this.qrcode, 60000)
      } else {
        this.destroyTimer()
      }
    },

    // 二维码生成，刷新之前的数据校验
    dataValidate () {
      if (this.dateStart === '') {
        this.$message.error('优惠券有效期起不能为空')
        return false
      }
      if (this.dateEnd === '') {
        this.$message.error('优惠券有效期止不能为空')
        return false
      }
      if (this.dateStart > this.dateEnd) {
        this.$message.error('优惠券有效期止不能早于有效期起')
        return false
      }
      if (this.couponVal === '') {
        this.$message.error('请选择优惠券金额')
        return false
      }
      return true
    },

    // 查询客户信息
    async queryMerchantInfo () {
      const merchantId = window.sessionStorage.getItem('merchantId')
      if (merchantId === null) {
        // 发送请求
        const token = window.sessionStorage.getItem('token')
        if (undefined === token || token === '') { // 判断用户登录是否有效
          this.$message.error('您的登录已失效，请重新登录')
          window.sessionStorage.clear()
          this.$router.push('/login')
        }
        const { data: res } = await this.$http.get('queryMerchantInfoByToken', { headers: { token: token } })
        // console.log(res)
        if (res.code === '0') {
          // 将商户ID存放到session
          window.sessionStorage.setItem('merchantId', res.data.merchantId)
          window.sessionStorage.setItem('couponMoneyList', res.data.couponMoneyList)
          window.sessionStorage.setItem('roadValidScope', res.data.roadValidScope)
          window.sessionStorage.setItem('thirdValidScope', res.data.thirdValidScope)
        } else {
          return this.$message.error(res.message)
        }
      }
      // 处理优惠券金额下拉列表数据
      var couponMoneyStr = window.sessionStorage.getItem('couponMoneyList')
      if (couponMoneyStr == null || couponMoneyStr === '') {
        couponMoneyStr = '1,2,5,10,20'
      }
      var couponMoneyArr = couponMoneyStr.split(',')
      for (var i = 0; i < couponMoneyArr.length; i++) {
        this.options.push({ value: couponMoneyArr[i], label: couponMoneyArr[i] + '元' })
      }
    },

    //  生成二维码通用方法
    async qrcode () {
      // 验证数据合法性
      if (!this.dataValidate()) {
        return false
      }
      // 后台获取二维码内容
      const token = window.sessionStorage.getItem('token')
      const merchantId = window.sessionStorage.getItem('merchantId')
      if (undefined === token || token === '') { // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      if (undefined === merchantId || merchantId === '') { // 判断获取用户信息是否成功
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      // 发送请求
      const dateStartStr = dateFormat(this.dateStart) + ' 00:00:00'
      const dateEndStr = dateFormat(this.dateEnd) + ' 23:59:59'
      const { data: res } = await this.$http.get('preCreateCoupon', { headers: { token: token }, params: { merchantId: merchantId, couponMoney: this.couponVal, beginDate: dateStartStr, endDate: dateEndStr } })
      // console.log(res)
      if (res.code === '0') {
        this.qrLink = res.data
        this.qrcodejs2()
        return true
      } else {
        this.$message.error(res.message)
        return false
      }
    },

    // 二维码生成方法
    qrcodejs2 () {
      document.getElementById('qrcode').innerHTML = ''// 首先清空二维码内容
      /* eslint-disable no-new */
      new QRCode('qrcode', { // 生成二维码
        width: 300,
        height: 300,
        text: this.qrLink // 二维码内容
      })
    },

    // 销毁定时器
    destroyTimer () {
      if (this.myTimer != null) {
        window.clearInterval(this.myTimer)// 出错删除定时器
      }
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.el-col {
  margin: 7px 7px 30px 7px;
}
.qr-card {
  width: 100%;
}
.image {
  width: 300px;
  height: 300px;
  display: block;
  margin: 0 auto;
  padding: 5px;;
}
</style>
